import { useEffect } from "react";

export default function TawkLoader() {
    useEffect(() => {
        if (process.env.NODE_ENV !== "production") return;

        const loadTawk = () => {
            if (window.Tawk_API || document.getElementById("tawk-script")) return;

            const script = document.createElement("script");
            script.id = "tawk-script";
            script.src = "https://embed.tawk.to/6881d5a37d26d01929e21f1d/1j0tp7oic";
            script.async = true;
            script.defer = true;
            script.charset = "UTF-8";
            script.crossOrigin = "*";

            document.body.appendChild(script);
        };

        const idleCallbackId = "requestIdleCallback" in window
            ? requestIdleCallback(loadTawk, { timeout: 5000 })
            : setTimeout(loadTawk, 5000);

        const events = ["scroll", "mousemove", "touchstart", "keydown"];
        events.forEach(event =>
            window.addEventListener(event, loadTawk, { once: true })
        );

        return () => {
            if ("cancelIdleCallback" in window) cancelIdleCallback(idleCallbackId);
            else clearTimeout(idleCallbackId);

            events.forEach(event =>
                window.removeEventListener(event, loadTawk)
            );
        };
    }, []);

    return null;
}
